import { Flex } from 'front-commons/ds';
import styled from 'styled-components';

export const IconWrapper = styled(Flex)`
	/* small {
		margin-top: -8px;
		margin-right: -20px;
	} */
`;
